import React, { Component } from "react";

import { connect } from "react-redux";
import ProductOptionGroup from "./Groups";
import { loadOptions } from "../../../store/actions";
import LoadingOptions from "./LoadingOptions";
import MainGroup from "./Groups/MainGroup";

class ProductOptions extends Component {
  state = { fetchingOptions: false };

  checkCondition = (option, checkGroups = false) => {
    if (!option.condition_parent) return true;
    const { selectedOptions, options } = this.props;
    let parentSelected =
      !!selectedOptions[option.condition_parent_option]?.selectedOptions?.[
        option.condition_parent
      ];

    if (!parentSelected && checkGroups) {
      const parent = options.find(
        (op) => op.id === option.condition_parent_option,
      );
      if (parent?.groups?.length) {
        return parent?.groups.some(
          (group) =>
            selectedOptions[`${option.condition_parent_option}-${group}`]
              ?.selectedOptions?.[option.condition_parent],
        );
      }
    }

    return parentSelected;
  };

  render() {
    if (this.props.resetOptions) {
      this.props.setResetOption();
      return <LoadingOptions />;
    }
    if (this.state.fetchingOptions) return <LoadingOptions />;

    const {
      options,
      discountAmount,
      controlOptions,
      selectedOptions,
      productQuantity,
      productUsedComponents,
      editedProduct,
      editMode,
      optionsGroups,
      hasPrevState,
    } = this.props;
    const themeColor = this.props.themeColor
      ? this.props.themeColor
      : "#0099cc";
    let optionsList = [];
    if (optionsGroups?.length > 0) {
      optionsList = [];

      optionsList = optionsGroups.map((og) => (
        <MainGroup key={og.id} sortOrder={og.sort_order} group={og}>
          {options
            .filter((o) => o.groups.includes(og.id))
            .map((op) => (
              <ProductOptionGroup
                hasPrevState={hasPrevState}
                key={op.id}
                option={op}
                controlOptions={controlOptions}
                selectedOptions={selectedOptions}
                themeColor={themeColor}
                allOptions={this.props.options}
                discountAmount={discountAmount}
                productQuantity={productQuantity}
                productUsedComponents={productUsedComponents}
                editedProduct={editedProduct}
                editMode={editMode}
                groupID={og.id}
                sortOrder={op.sort_order}
              />
            ))}
        </MainGroup>
      ));
      // change to single loop and check if group was deleted :)
      options.forEach((op) => {
        if (op.groups.length <= 0 && !op.condition_parent) {
          optionsList.push(
            <ProductOptionGroup
              hasPrevState={hasPrevState}
              key={op.id}
              option={op}
              controlOptions={controlOptions}
              selectedOptions={selectedOptions}
              themeColor={themeColor}
              allOptions={this.props.options}
              discountAmount={discountAmount}
              productQuantity={productQuantity}
              productUsedComponents={productUsedComponents}
              editedProduct={editedProduct}
              editMode={editMode}
              inInGroup={false}
              sortOrder={op.sort_order}
            />,
          );
        }
      });

      optionsList.sort((a, b) => a.props.sortOrder - b.props.sortOrder);
    } else {
      optionsList = options
        .filter((option) => !option.condition_parent)
        .map((op) => (
          <ProductOptionGroup
            hasPrevState={hasPrevState}
            key={op.id}
            option={op}
            controlOptions={controlOptions}
            selectedOptions={selectedOptions}
            allOptions={this.props.options}
            themeColor={themeColor}
            discountAmount={discountAmount}
            productQuantity={productQuantity}
            productUsedComponents={productUsedComponents}
            editedProduct={editedProduct}
            editMode={editMode}
            inInGroup={false}
            sortOrder={op.sort_order}
          />
        ));
    }

    return optionsList;
  }
}
const mapStateToProps = (state) => {
  return {
    themeColor: state.store.store.settings.dark,
    store: state.store.store,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    loadOptions: (productID, categoryID) =>
      dispatch(loadOptions(productID, categoryID)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductOptions);
